getChatBlockedUsersMiddleWare